import i18n from '@/plugins/i18n'

export default [
  {
    path: 'content/:id',
    name: 'ContentDetails',
    component: () => import('./User/ContentDetails/PgContentDetails.vue'),
    portalGroup: 'learn.public',
    meta: { title: i18n.t('l0101.edit.content.title') }
  },
  {
    path: 'calendar',
    name: 'Calendar',
    component: () => import('./User/PgCalendar.vue'),
    portalGroup: 'learn.my',
    meta: { authenticated: true, title: i18n.t('l0101.calendar.title'), permissions: ['content.calender'] }
  },
  // TODO: [Adrian] finalize use lecture or scholar (route naming vs file naming)
  {
    path: 'Contents',
    name: 'ContentList',
    component: () => import('./Scholar/ContentList/PgContentList'),
    portalGroup: 'learn.lecture',
    meta: { authenticated: true, permissions: ['content.browse'] }
  },
  {
    path: 'Contents/create',
    name: 'ContentCreate',
    component: () => import('./Scholar/ContentCreate/PgContentCreate'),
    portalGroup: 'learn.lecture',
    meta: { title: i18n.t('l0101.add.title'), authenticated: true, permissions: ['content.add'] }
  },
  {
    path: 'Contents/:id/preview',
    name: 'ContentPreview',
    component: () => import('./Scholar/ContentPreview/PgContentPreview'),
    portalGroup: 'learn.lecture',
    meta: { authenticated: true, permissions: ['content.read'] }
  },
  {
    path: 'Contents/:id/edit',
    name: 'ContentEdit',
    component: () => import('./Scholar/ContentEdit/PgContentEdit'),
    portalGroup: 'learn.lecture',
    meta: { title: i18n.t('l0101.edit.title'), authenticated: true, permissions: ['content.edit'] }
  },
  {
    path: 'Contents/:id/review',
    name: 'ContentReview',
    component: () => import('./Admin/ContentReview/PgContentReview'),
    portalGroup: 'learn.lecture',
    meta: { authenticated: true, permissions: ['content.read', 'approval.review'] }
  }
]
